// extracted by css-extract-rspack-plugin
export default {"contextMenu":"contextMenu-2c7ye","popup":"popup-2hwx2","group":"group-1tiqp","quickbar":"quickbar-12hiP","labelHeader":"labelHeader-3asxd"};